import { Grid, Typography, Box } from '@mui/material';
import { motion, AnimatePresence } from 'framer-motion';
import React from 'react';
import banner from '../../images/admissionbanner.png';

const textVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: 'easeOut' } }
};

const Banner = () => {
    return (
        <Grid
            container
            spacing={0}
            sx={{
                position: 'relative',
                height: { md: '60vh', sm: '40vh', xs: '50vh' },
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundImage: `url(${banner})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                overflow: 'hidden'
            }}
        >
            {/* Dark Overlay */}
            <Box
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    background: 'linear-gradient(to right, rgba(26,35,126,0.8), rgba(0,0,0,0.5))',
                    zIndex: 1,
                }}
            />

            {/* Animated Content */}
            <Box
                component={motion.div}
                initial="hidden"
                animate="visible"
                variants={textVariants}
                sx={{
                    textAlign: 'center',
                    zIndex: 2,
                    color: '#fff',
                    padding: { xs: 3, md: 6 },
                    position: 'relative',
                    width: '100%',
                    maxWidth: '800px'
                }}
            >
                <Typography
                    variant="h2"
                    sx={{
                        fontWeight: 800,
                        color: '#fff',
                        fontSize: { xs: '32px', md: '56px', sm: '44px' },
                        textShadow: '0 4px 12px rgba(0,0,0,0.5)',
                        letterSpacing: '1px',
                        mb: 2
                    }}
                >
                    College Admissions
                </Typography>
                <Typography
                    variant="h5"
                    sx={{
                        color: '#e0e0e0',
                        fontSize: { xs: '18px', md: '24px', sm: '20px' },
                        textShadow: '0 2px 8px rgba(0,0,0,0.5)'
                    }}
                >
                    Find the best colleges and secure your admission now.
                </Typography>
            </Box>
        </Grid>
    );
};

export default Banner;
